import {
  GoogleLogin,
  GoogleLoginProps,
  GoogleOAuthProvider,
} from '@react-oauth/google';

import {GOOGLE_CLIENT_ID} from '@/shared/config';

export type {CredentialResponse} from '@react-oauth/google';

type GoogleOauthButtonProps = {
  locale: string;
} & GoogleLoginProps;

export default function GoogleOauthButton({
  locale,
  ...props
}: GoogleOauthButtonProps) {
  return (
    <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID} locale={locale}>
      <GoogleLogin {...props} />
    </GoogleOAuthProvider>
  );
}
